export default __webpack_public_path__ + "static/media/diagram-en.99cabb7d.webp";